import { Storage } from 'aws-amplify';
import axios from 'axios';
import DOMPurify from 'dompurify';
import moment from 'moment';
import { Fragment, useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { useHistory, useParams } from 'react-router-dom';
import DeleteModal from './DeleteModal';
import VisibleToModal from './VisibleToModal';
import { CommonLoading } from 'react-loadingg';
import { SendBulletinNotiModal } from '.';

const ViewBulletin = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [showEdit, setShowEdit] = useState(false);
    const [showSelfEdit, setShowSelfEdit] = useState(false);
    const [bulletins, setBulletins] = useState('');
    const [title, setTitle] = useState('');
    const [encodedHtmlContent, setEncodedHtmlContent] = useState('');
    const [htmlContent, setHtmlContent] = useState('');
    const [employee, setEmployee] = useState([]);
    const [entity, setEntity] = useState([]);
    const [image, setImage] = useState('');
    const [displayImage, setDisplayImage] = useState('');
    const [viewCount, setViewCount] = useState('');
    const [liveStatus, setLiveStatus] = useState('');
    const [createdDate, setCreatedDate] = useState('');
    const [createdBy, setCreatedBy] = useState('');

    const [dropdown, setShowDropdown] = useState(false);
    const showDropDown = () => setShowDropdown(!dropdown);

    const [deleteModal, setOpenDeleteModal] = useState(false);
    const handleDeleteModal = () => setOpenDeleteModal(!deleteModal);

    const [visibleModal, setOpenVisibleModal] = useState(false);
    const handleVisibleModal = () => setOpenVisibleModal(!visibleModal);

    const [notiModal, setOpenNotiModal] = useState(false);
    const openNotiModal = () => setOpenNotiModal(!notiModal);
    const closeNotiModal = () => setOpenNotiModal(!notiModal);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    const { id } = useParams();

    const history = useHistory();

    const ref = useRef();
    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            // If the menu is open and the clicked target is not within the menu,
            // then close the menu
            if (dropdown && ref.current && !ref.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', checkIfClickedOutside);
        return () => {
            // Cleanup the event listener
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [dropdown, ref]);

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Bulletin Board') &&
                        item.permissionType.includes('view'))
            );

            const editPermit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('edit')) ||
                    (item.permissionName.includes('Bulletin Board') &&
                        item.permissionType.includes('edit'))
            );

            if (editPermit) {
                setShowEdit(true);
            }

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            } else {
                setIsLoading(false);
            }

            if (
                bulletins.createdByID === props.badgeID ||
                loginListFromParent.some(
                    (item) =>
                        item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('edit')
                )
            ) {
                setShowSelfEdit(true);
            }
        }
    }, [props.loginList, props.badgeID, bulletins.createdByID]);

    // Find the bulletin with matching id
    useEffect(() => {
        const getBulletinInfo = async () => {
            const bulletinFromServer = await fetchBulletinInfo();
            const item = bulletinFromServer.find(
                (bulletin) => bulletin.bbID === id
            );
            setBulletins(item);
        };

        getBulletinInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    // Fetch Bulletin
    const fetchBulletinInfo = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/bulletinboard/getbulletin'
        );
        const data = await res.json();

        return data.BBoardList;
    };

    useEffect(() => {
        const insertData = () => {
            setTitle(bulletins.title);
            if (bulletins.employee) {
                let employeeArray = bulletins.employee.split(',');
                setEmployee(employeeArray);
            }
            if (bulletins.entity) {
                let entityArray = bulletins.entity.split(',');
                setEntity(entityArray);
            }
            setImage(bulletins.image);
            setEncodedHtmlContent(bulletins.desc);
            setViewCount(bulletins.viewCount);
            setLiveStatus(bulletins.liveStatus);
            setCreatedBy(bulletins.createdBy);
            setCreatedDate(
                moment(bulletins.createdDate).format('DD MMMM YYYY')
            );
        };

        insertData();
    }, [bulletins]);

    useEffect(() => {
        const decodeContent = () => {
            let decodedHtml = decodeURIComponent(encodedHtmlContent);
            setHtmlContent(decodedHtml);
        };

        decodeContent();
    }, [encodedHtmlContent]);

    useEffect(() => {
        fetchImage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [image]);

    async function fetchImage() {
        if (image) {
            const imageUrl = await Storage.get(image);
            setDisplayImage(imageUrl);
        }
    }

    // Delete Bulletin
    const deleteBulletin = (bulletin) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/bulletinboard/deletebulletin';

        const bulletinDetails = {
            bbID: bulletin.id,
            deletedBy: bulletin.deletedBy,
        };
        axios
            .post(url, bulletinDetails)
            .then(
                (response) => alert('Bulletin has been successfully deleted!'),
                setTimeout(() => {
                    history.push('/bulletinboard');
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    const sendNotification = (noti) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/bulletinboard/pushnoti';
        const notification = noti.notification;
        const requests = [];

        for (let i = 0; i < notification.length; i++) {
            requests.push(
                axios.post(url, {
                    id: notification[i].id,
                    title: notification[i].title,
                    employee: notification[i].employee.toLowerCase(),
                })
            );
        }

        axios
            .all(requests)
            .then(
                axios.spread((...responses) => {
                    alert('Notification has been successfully sent!');
                    setTimeout(() => {
                        setOpenNotiModal(!notiModal);
                    }, 500);
                })
            )
            .catch((err) => {
                console.error(err);
            });
    };

    const createMarkup = (html) => {
        return {
            __html: DOMPurify.sanitize(html, {
                ADD_TAGS: ['iframe'],
                ADD_ATTR: [
                    'allow',
                    'allowfullscreen',
                    'frameborder',
                    'scrolling',
                ],
            }),
        };
    };

    const setStyle = () => {
        let styles = {};
        if (showSelfEdit && showEdit) {
            const firstStyle = {
                cursor: 'default',
                textTransform: 'capitalize',
                width: '105px',
                padding: '0px',
                height: '30px',
                marginRight: '25px',
            };
            styles = Object.assign(styles, firstStyle);
        } else {
            const firstStyle = {
                cursor: 'default',
                textTransform: 'capitalize',
                width: '105px',
                padding: '0px',
                height: '30px',
            };
            styles = Object.assign(styles, firstStyle);
        }
        return styles;
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '50px',
                        }}
                    >
                        <Row>
                            <Col xs={12} md={12}>
                                <Row>
                                    <Col xs={6} md={6}>
                                        {/* <Button
                                        onClick={() => history.push('/bulletinboard')}
                                        style={{
                                            width: '80px',
                                            padding: '0px',
                                            height: '30px',
                                        }}
                                    > */}
                                        <Button
                                            onClick={() =>
                                                history.push('/bulletinboard')
                                            }
                                        >
                                            &#60; Back
                                        </Button>
                                    </Col>
                                    <Col
                                        xs={6}
                                        md={6}
                                        style={{ textAlign: 'right' }}
                                    >
                                        {liveStatus && (
                                            <Button
                                                variant={`${
                                                    liveStatus === 'live'
                                                        ? 'success'
                                                        : liveStatus === 'end'
                                                        ? 'danger'
                                                        : 'warning'
                                                }`}
                                                style={setStyle()}
                                            >
                                                {liveStatus}
                                            </Button>
                                        )}
                                        {showSelfEdit && showEdit && (
                                            <div
                                                className='ellipsis-menu'
                                                ref={ref}
                                                style={{ position: 'inherit' }}
                                            >
                                                <FaIcons.FaEllipsisH
                                                    onClick={showDropDown}
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                                {dropdown && (
                                                    <div
                                                        className='dropdown-content'
                                                        style={{
                                                            position: 'fixed',
                                                        }}
                                                    >
                                                        <button
                                                            className='ellipsis-menu-btn'
                                                            onClick={() =>
                                                                history.push(
                                                                    `/bulletinboard/edit/${bulletins.bbID}`
                                                                )
                                                            }
                                                        >
                                                            Edit
                                                        </button>
                                                        <button
                                                            className='ellipsis-menu-btn'
                                                            onClick={
                                                                handleDeleteModal
                                                            }
                                                        >
                                                            Delete
                                                        </button>
                                                        <DeleteModal
                                                            show={deleteModal}
                                                            handleClose={
                                                                handleDeleteModal
                                                            }
                                                            id={bulletins.bbID}
                                                            onDelete={
                                                                deleteBulletin
                                                            }
                                                        />
                                                        <button
                                                            className='ellipsis-menu-btn'
                                                            onClick={
                                                                openNotiModal
                                                            }
                                                        >
                                                            Send Notification
                                                        </button>
                                                        <SendBulletinNotiModal
                                                            show={notiModal}
                                                            handleClose={
                                                                closeNotiModal
                                                            }
                                                            bulletin={bulletins}
                                                            onPushNoti={
                                                                sendNotification
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                                <hr />
                                <Row>
                                    <Col xs={6} md={6}>
                                        {createdBy && <p>{createdBy}</p>}
                                        {createdDate && (
                                            <p>Created on {createdDate}</p>
                                        )}
                                    </Col>
                                    <Col xs={6} md={6}>
                                        {viewCount && viewCount > 1 ? (
                                            <div
                                                className='flex-container'
                                                style={{
                                                    justifyContent: 'flex-end',
                                                }}
                                            >
                                                <FaIcons.FaEye
                                                    style={{ margin: '5px' }}
                                                />
                                                <p>{viewCount} Views</p>
                                            </div>
                                        ) : (
                                            <div
                                                className='flex-container'
                                                style={{
                                                    justifyContent: 'flex-end',
                                                }}
                                            >
                                                <FaIcons.FaEye
                                                    style={{ margin: '5px' }}
                                                />
                                                <p>{viewCount} View</p>
                                            </div>
                                        )}
                                        {employee && entity && (
                                            <p
                                                className='visible-to-link'
                                                onClick={handleVisibleModal}
                                            >
                                                Visible to{' '}
                                                {employee.length > 1 ? (
                                                    <>
                                                        {employee.length}{' '}
                                                        Employees{' '}
                                                    </>
                                                ) : (
                                                    <>
                                                        {employee.length}{' '}
                                                        Employee{' '}
                                                    </>
                                                )}
                                                {entity.length > 1 ? (
                                                    <>
                                                        ({entity.length}{' '}
                                                        Entities)
                                                    </>
                                                ) : (
                                                    <>
                                                        ({entity.length} Entity)
                                                    </>
                                                )}
                                            </p>
                                        )}
                                        <VisibleToModal
                                            show={visibleModal}
                                            handleClose={handleVisibleModal}
                                            employee={employee}
                                            entity={entity}
                                        />
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '30px' }}>
                                    {title && (
                                        <p style={{ fontWeight: 'bold' }}>
                                            {title}
                                        </p>
                                    )}
                                    {htmlContent && (
                                        <div
                                            dangerouslySetInnerHTML={createMarkup(
                                                htmlContent
                                            )}
                                        />
                                    )}
                                    <div>
                                        <p style={{ fontWeight: 'bold' }}>
                                            Attachment
                                        </p>
                                        {displayImage && (
                                            <img
                                                src={displayImage}
                                                alt=''
                                                style={{
                                                    width: '40%',
                                                    // display: 'block',
                                                    // marginLeft: 'auto',
                                                    // marginRight: 'auto',
                                                }}
                                            />
                                        )}
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default ViewBulletin;
